import { Compass, Target } from "lucide-react";

export default function MissionVision() {
  return (
    <section
      id="story"
      data-testid="mission-vision-section"
      className="py-20 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 grid md:grid-cols-12 gap-10 md:gap-16 items-start">
        <div className="md:col-span-5">
          <div className="relative">
            <div className="absolute -inset-4 bg-[#EBE4D8] rounded-[2.5rem] -z-10" />
            <div className="relative overflow-hidden rounded-2xl aspect-[4/5]">
              <img
                src="https://images.unsplash.com/photo-1506126613408-eca07ce68773"
                alt="Meditation in nature"
                className="h-full w-full object-cover transition-transform duration-700 hover:scale-105"
              />
            </div>
          </div>
        </div>

        <div className="md:col-span-7 md:pt-8">
          <span className="overline">Story · Mission · Vision</span>
          <h2 className="mt-4 font-serif-display text-4xl sm:text-5xl md:text-6xl leading-[1.05] tracking-tight">
            Wellness beyond
            <span className="italic text-[#C05C46]"> relief.</span>
          </h2>

          <p className="mt-6 max-w-xl text-lg leading-relaxed text-[#5C6B5D]">
            We began where every good Ayurvedic story begins — around a kitchen
            table, with grandmothers, with herbs, and with the belief that
            healing is a slow, respectful conversation with the body.
          </p>

          <div className="mt-12 space-y-10">
            <Pillar
              icon={<Target className="h-5 w-5" strokeWidth={1.5} />}
              label="Our Mission"
              body="To improve people's quality of life through natural Ayurvedic solutions — helping them achieve better health, inner peace, and lasting well-being."
              testId="mission-block"
            />
            <div className="h-px bg-[#DCD3C6]" />
            <Pillar
              icon={<Compass className="h-5 w-5" strokeWidth={1.5} />}
              label="Our Vision"
              body="To become a trusted global Ayurvedic healthcare brand that empowers people to live healthier, happier, and stress-free lives."
              testId="vision-block"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function Pillar({ icon, label, body, testId }) {
  return (
    <div data-testid={testId} className="grid grid-cols-[auto,1fr] gap-6">
      <span className="mt-1 inline-flex h-11 w-11 items-center justify-center rounded-full bg-[#2E3A2F] text-[#F8F5F0]">
        {icon}
      </span>
      <div>
        <div className="overline">{label}</div>
        <p className="mt-3 font-serif-display text-2xl md:text-3xl leading-snug text-[#2E3A2F]">
          {body}
        </p>
      </div>
    </div>
  );
}
